import React from 'react';
import { Box, Flex, IconButton, Text, VStack } from '@chakra-ui/react';
import { FiChevronLeft, FiHelpCircle } from 'react-icons/fi';
import { wizardTokens } from '../styles';

interface WizardHeaderProps {
  stepIndex: number;
  // Total number of steps / pills.
  progressCount: number;
  /** Name of the current step, shown after "Step X of Y ·" (board BookVisit header). */
  title?: string;
  onBack: () => void;
  onSupport: () => void;
}

const ICON_BTN = {
  flex: 'none',
  w: '44px',
  h: '44px',
  minW: '44px',
  borderRadius: 'full',
  bg: 'transparent',
  color: wizardTokens.ink,
  _hover: { bg: '#F2F2F0' },
  _active: { bg: '#F2F2F0' },
} as const;

// Wizard chrome (board BookVisit): back · "STEP X OF Y · NAME" over segmented progress · support.
const WizardHeader: React.FC<WizardHeaderProps> = ({
  stepIndex,
  progressCount,
  title,
  onBack,
  onSupport,
}) => {
  const displayStep = Math.min(stepIndex + 1, progressCount);
  return (
    <Flex p="12px 12px 0 12px" align="center" gap="8px" fontFamily="display">
      <IconButton aria-label="Go back" icon={<FiChevronLeft size={22} strokeWidth={2.4} />} onClick={onBack} {...ICON_BTN} />
      <VStack flex={1} align="stretch" spacing="6px" minW={0}>
        <Text
          fontSize="12px"
          fontWeight={600}
          letterSpacing="0.08em"
          textTransform="uppercase"
          color="#55555A"
          lineHeight="normal"
          noOfLines={1}
        >
          Step {displayStep} of {progressCount}
          {title ? ` · ${title}` : ''}
        </Text>
        <Flex gap="4px" aria-hidden>
          {Array.from({ length: progressCount }).map((_, i) => (
            <Box
              key={i}
              flex={1}
              h="4px"
              borderRadius="999px"
              bg={i <= stepIndex ? wizardTokens.progressActive : wizardTokens.progressInactive}
              transition="background 0.2s"
            />
          ))}
        </Flex>
      </VStack>
      <IconButton aria-label="Support" icon={<FiHelpCircle size={20} strokeWidth={2.2} />} onClick={onSupport} {...ICON_BTN} />
    </Flex>
  );
};

export default WizardHeader;
